import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { Facet } from 'src/redux/productsQuery/types/Facet';

export const selectFacetByKey = (state: ReduxApplicationState, uid: string): Facet | null => {
  return state.productsQuery.facets.find((facet) => facet.key === uid) || null;
};

export const selectTotalActiveOptions = (state: ReduxApplicationState) => {
  return state.productsQuery.facets.reduce((total, facet) => {
    const activeOptionsCount = facet.options.filter((option) => option.active).length;

    total = total + activeOptionsCount;

    return total;
  }, 0);
};

export const selectActiveFacets = (state: ReduxApplicationState) => {
  return state.productsQuery.facets.filter((facet) =>
    facet.options.some((option) => option.active),
  );
};

/**
 * Active facets that are NOT taxonomy levels. Taxonomy selections come from the
 * taxonomy navigation, not the filter sidebar, so they must not be surfaced as
 * "applied filters" or counted in filter badges.
 */
export const selectActiveNonTaxonomyFacets = (state: ReduxApplicationState) => {
  const taxonomyAliases = state.productsQuery.taxonomyAttributeAliases ?? [];

  return selectActiveFacets(state).filter((facet) => !taxonomyAliases.includes(facet.alias));
};

/** Count of active options across non-taxonomy facets (for filter-count badges). */
export const selectTotalActiveNonTaxonomyOptions = (state: ReduxApplicationState) => {
  return selectActiveNonTaxonomyFacets(state).reduce(
    (total, facet) => total + facet.options.filter((option) => option.active).length,
    0,
  );
};

export const selectActiveSortOption = (state: ReduxApplicationState) => {
  return state.productsQuery.sortOptions.find((option) => option.active) || null;
};
